import React from "react";
import { LogoutOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import Button from "@components/common/Button/Button";

interface LogoutConfirmationModalProps {
	show: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({ show, onConfirm, onCancel }) => {
	const { t } = useTranslation();

	if (!show) return null;

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20">
			<div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-xl">
				{/* Icon */}
				<div className="flex justify-center mb-6">
					<div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
						<LogoutOutlined className="text-orange-500" sx={{ fontSize: "2rem" }} />
					</div>
				</div>

				{/* Title */}
				<h2 className="text-xl font-bold text-gray-900 text-center mb-2">{t("psdaCommon.logout.title")}</h2>

				{/* Description */}
				<p className="text-gray-600 text-center mb-8">{t("psdaCommon.logout.description")}</p>

				{/* Action Buttons */}
				<div className="flex gap-4">
					<Button
						variant="dangerTertiary"
						onClick={onCancel}
						className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-50">
						{t("psdaCommon.common.buttons.no")}
					</Button>
					<Button variant="dangerSecondary" onClick={onConfirm} className="flex-1">
						{t("psdaCommon.common.buttons.yes")}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default LogoutConfirmationModal;
